
const Rule = ({ id }) => {

	const ident = id;

	return (
		<div id={ident} className="main__rule rule-main">
			<div className="rule-main__shape rule-main__shape_1">
				<img src='assets/images/mainPage/rule/shape_1.png' alt="" />
			</div>
			<div className="rule-main__shape rule-main__shape_2">
				<img src='assets/images/mainPage/rule/shape_2.png' alt="" />
			</div>
			<div className="rule-main__body">
				<h3 className='rule-main__title'>
					StydyPipe — новый подход к образованию. Работает по принципу — «обучайся сам и обучай других»
				</h3>
			</div>
		</div>
	)
}


export default Rule;